import { queryOptions, useQuery } from '@tanstack/react-query';

import { sizeSetsApi } from '../api/size-sets-api';

import { dictionaryKeys } from './dictionary-keys';

/** Ring, apparel and shoe size scales; select customizations draw their options from one. */
export function sizeSetsQueryOptions() {
  return queryOptions({
    queryKey: dictionaryKeys.sizeSets(),
    queryFn: sizeSetsApi.list,
    staleTime: 5 * 60_000,
  });
}

export function useSizeSets() {
  return useQuery(sizeSetsQueryOptions());
}
